import { useFilterEmployeeTimelineContext } from "./filter-employee-timeline.context";

export function FilterEmployeeTimeline() {
  const { dateFilterElement, reportFilterElements, clearFiltersElement } =
    useFilterEmployeeTimelineContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {reportFilterElements}
      {clearFiltersElement}
    </div>
  );
}